import { createAsyncThunk, isRejected } from '@reduxjs/toolkit';
import {
  actions as appStorageActions,
  records as appStorageRecords,
  utils as appStorageUtils,
} from '@saucelabs/sl-module-app-storage';
import { actions as notificationActions } from '@saucelabs/sl-container-notifications';

import actions from './actions';
import types from './types';

const deleteAndRefreshGroups = createAsyncThunk(
  types.DELETE_GROUP,
  async (group: appStorageRecords.AppStorageGroup, { dispatch, rejectWithValue }) => {
    try {
      const response = await dispatch(appStorageActions.deleteGroup(group.id));

      // Refresh the group table after the delete request finished
      await dispatch(actions.fetchGroups());

      if (isRejected(response)) {
        const serverError = response.payload as appStorageUtils.SerializedApiError;
        throw serverError;
      }

      const deletedGroup = response.payload.items[0];
      dispatch(notificationActions.notifySuccess(
        `Successfully deleted ${deletedGroup.name} with ID: ${deletedGroup.id}`,
        undefined,
        false,
        undefined,
        true,
      ));

      return deletedGroup;
    } catch (error) {
      let apiError: appStorageUtils.SerializedApiError;

      if (error instanceof Error) {
        apiError = appStorageUtils.handleApiError(error);
      } else {
        apiError = error as appStorageUtils.SerializedApiError;
      }

      const {
        code,
        detail,
        title,
      } = apiError.error;

      dispatch(notificationActions.notifyDanger(
        `Deleting the app group did not complete as expected. ${detail}`,
        `${code} ${title}`,
        true,
        undefined,
        true,
      ));
      return rejectWithValue(apiError);
    }
  },
);

export default {
  deleteAndRefreshGroups,
};
